// Iter77 — Static universe mirror from /app/backend/scanner_universe.py.
//
// Frozen snapshots of the S&P 500 + Russell 1000-additions ticker
// universes. These power the Strategy Scanner Source Selector
// (Iter77) WITHOUT requiring any new backend endpoint.
//
// HARD CONSTRAINTS:
//  * No network primitive used to populate either list.
//  * Lists are mirrored verbatim from the canonical Python module
//    `scanner_universe.py` (the same source the existing Market
//    Scanner uses for its universe).
//  * Russell 2000 is intentionally NOT provided — this engine's
//    universe is Russell 1000 (IWB). The Iter77 bridge surfaces
//    Russell 2000 as a disabled source with an explanation.

export const SP500_UNIVERSE = Object.freeze([
  "A", "AAPL", "ABBV", "ABNB", "ABT", "ACGL", "ACN", "ADBE", "ADI", "ADM", "ADP", "ADSK",
  "AEE", "AEP", "AES", "AFL", "AIG", "AIZ", "AJG", "AKAM", "ALB", "ALGN", "ALL", "ALLE",
  "AMAT", "AMCR", "AMD", "AME", "AMGN", "AMP", "AMT", "AMZN", "ANET", "ANSS", "AON", "AOS",
  "APA", "APD", "APH", "APTV", "ARE", "ATO", "ATVI", "AVB", "AVGO", "AVY", "AWK", "AXP",
  "AZO", "BA", "BAC", "BAX", "BBWI", "BBY", "BDX", "BEN", "BF.B", "BG", "BIIB", "BIO",
  "BK", "BKNG", "BKR", "BLDR", "BLK", "BMY", "BR", "BRK.B", "BRO", "BSX", "BWA", "BX",
  "BXP", "C", "CAG", "CAH", "CARR", "CAT", "CB", "CBOE", "CBRE", "CCI", "CCL", "CDAY",
  "CDNS", "CDW", "CE", "CEG", "CF", "CFG", "CHD", "CHRW", "CHTR", "CI", "CINF", "CL",
  "CLX", "CMA", "CMCSA", "CME", "CMG", "CMI", "CMS", "CNC", "CNP", "COF", "COO", "COP",
  "COR", "COST", "CPAY", "CPB", "CPRT", "CPT", "CRL", "CRM", "CRWD", "CSCO", "CSGP", "CSX",
  "CTAS", "CTLT", "CTRA", "CTSH", "CTVA", "CVS", "CVX", "CZR", "D", "DAL", "DAY", "DD",
  "DE", "DECK", "DFS", "DG", "DGX", "DHI", "DHR", "DIS", "DISH", "DLR", "DLTR", "DOV",
  "DOW", "DPZ", "DRI", "DTE", "DUK", "DVA", "DVN", "DXCM", "EA", "EBAY", "ECL", "ED",
  "EFX", "EIX", "EL", "EMN", "EMR", "ENPH", "EOG", "EPAM", "EQIX", "EQR", "EQT", "ES",
  "ESS", "ETN", "ETR", "ETSY", "EVRG", "EW", "EXC", "EXPD", "EXPE", "EXR", "F", "FANG",
  "FAST", "FBHS", "FCX", "FDS", "FDX", "FE", "FFIV", "FI", "FICO", "FIS", "FISV", "FITB",
  "FLT", "FMC", "FOX", "FOXA", "FRT", "FSLR", "FTNT", "FTV", "GD", "GDDY", "GE", "GEHC",
  "GEN", "GILD", "GIS", "GL", "GLW", "GM", "GNRC", "GOOG", "GOOGL", "GPC", "GPN", "GRMN",
  "GS", "GWW", "HAL", "HAS", "HBAN", "HCA", "HD", "HOLX", "HON", "HPE", "HPQ", "HRL",
  "HSIC", "HST", "HSY", "HUBB", "HUM", "HWM", "IBM", "ICE", "IDXX", "IEX", "IFF", "ILMN",
  "INCY", "INTC", "INTU", "INVH", "IP", "IPG", "IQV", "IR", "IRM", "ISRG", "IT", "ITW",
  "IVZ", "J", "JBHT", "JBL", "JCI", "JKHY", "JNJ", "JNPR", "JPM", "K", "KDP", "KEY",
  "KEYS", "KHC", "KIM", "KKR", "KLAC", "KMB", "KMI", "KMX", "KO", "KR", "KVUE", "L",
  "LDOS", "LEN", "LH", "LHX", "LIN", "LKQ", "LLY", "LMT", "LNT", "LOW", "LRCX", "LULU",
  "LUV", "LVS", "LW", "LYB", "LYV", "MA", "MAA", "MAR", "MAS", "MCD", "MCHP", "MCK",
  "MCO", "MDLZ", "MDT", "MET", "META", "MGM", "MHK", "MKC", "MKTX", "MLM", "MMC", "MMM",
  "MNST", "MO", "MOH", "MOS", "MPC", "MPWR", "MRK", "MRNA", "MRO", "MS", "MSCI", "MSFT",
  "MSI", "MTB", "MTCH", "MTD", "MU", "NCLH", "NDAQ", "NDSN", "NEE", "NEM", "NFLX", "NI",
  "NKE", "NOC", "NOW", "NRG", "NSC", "NTAP", "NTRS", "NUE", "NVDA", "NVR", "NWL", "NWS",
  "NWSA", "NXPI", "O", "ODFL", "OGN", "OKE", "OMC", "ON", "ORCL", "ORLY", "OTIS", "OXY",
  "PARA", "PAYC", "PAYX", "PCAR", "PCG", "PEAK", "PEG", "PEP", "PFE", "PFG", "PG", "PGR",
  "PH", "PHM", "PKG", "PLD", "PM", "PNC", "PNR", "PNW", "PODD", "POOL", "PPG", "PPL",
  "PRU", "PSA", "PSX", "PTC", "PVH", "PWR", "PXD", "PYPL", "QCOM", "QRVO", "RCL", "RE",
  "REG", "REGN", "RF", "RHI", "RJF", "RL", "RMD", "ROK", "ROL", "ROP", "ROST", "RSG",
  "RTX", "RVTY", "SBAC", "SBUX", "SCHW", "SEE", "SHW", "SJM", "SLB", "SNA", "SNPS", "SO",
  "SPG", "SPGI", "SRE", "STE", "STLD", "STT", "STX", "STZ", "SWK", "SWKS", "SYF", "SYK",
  "SYY", "T", "TAP", "TDG", "TDY", "TECH", "TEL", "TER", "TFC", "TFX", "TGT", "TJX",
  "TMO", "TMUS", "TPR", "TRGP", "TRMB", "TROW", "TRV", "TSCO", "TSLA", "TSN", "TT", "TTWO",
  "TXN", "TXT", "TYL", "UAL", "UBER", "UDR", "UHS", "ULTA", "UNH", "UNP", "UPS", "URI",
  "USB", "V", "VFC", "VICI", "VLO", "VLTO", "VMC", "VRSN", "VRTX", "VST", "VTR", "VTRS",
  "VZ", "WAB", "WAT", "WBA", "WBD", "WDC", "WEC", "WELL", "WFC", "WHR", "WM", "WMB",
  "WMT", "WRB", "WRK", "WST", "WTW", "WY", "WYNN", "XEL", "XOM", "XRAY", "XYL", "YUM",
  "ZBH", "ZBRA", "ZTS",
]);

export const RUSSELL_1000_ADDITIONS = Object.freeze([
  "AA", "AAL", "AAON", "ACHC", "ACI", "ACM", "ADC", "ADT", "AFG", "AFRM", "AGCO", "AGNC",
  "AGO", "AIT", "ALAB", "ALGM", "ALK", "ALLY", "ALNY", "ALSN", "AM", "AMG", "AMH", "AMKR",
  "AMTM", "AN", "APG", "APLS", "APO", "APP", "APPF", "AR", "ARES", "ARMK", "ARW", "ASH",
  "ASTS", "ATI", "ATR", "AU", "AUR", "AVT", "AVTR", "AWI", "AXON", "AXS", "AXTA", "AYI",
  "BAH", "BALL", "BAM", "BC", "BEPC", "BFAM", "BHF", "BILL", "BIRK", "BJ", "BLD", "BMRN",
  "BOKF", "BPOP", "BRBR", "BRKR", "BROS", "BRX", "BSY", "BURL", "BWXT", "BYD", "CACC", "CACI",
  "CAR", "CART", "CASY", "CAVA", "CBSH", "CCC", "CCK", "CELH", "CFR", "CG", "CGNX", "CHDN",
  "CHE", "CHH", "CHRD", "CHWY", "CIEN", "CLF", "CLH", "CLVT", "CNA", "CNH", "CNM", "CNXC",
  "COHR", "COIN", "COKE", "COLB", "COLD", "COLM", "CORT", "COTY", "CPNG", "CR", "CRH", "CROX",
  "CRS", "CRUS", "CSL", "CUBE", "CUZ", "CVNA", "CW", "CWEN", "DAR", "DASH", "DBX", "DCI",
  "DDOG", "DDS", "DELL", "DINO", "DJT", "DKNG", "DKS", "DLB", "DOC", "DOCS", "DOCU", "DOX",
  "DRS", "DT", "DTM", "DUOL", "DV", "DXC", "EEFT", "EG", "EGP", "EHC", "ELAN", "ELF",
  "ELS", "ELV", "EME", "ENTG", "EPR", "EQH", "ESAB", "ESTC", "EVR", "EWBC", "EXE", "EXEL",
  "EXLS", "EXP", "FAF", "FBIN", "FCN", "FCNCA", "FERG", "FHB", "FHN", "FIVE", "FIX", "FLEX",
  "FLO", "FLS", "FLUT", "FNB", "FND", "FNF", "FOUR", "FR", "FRPT", "FTAI", "FTI", "G",
  "GAP", "GEV", "GFS", "GGG", "GLOB", "GLPI", "GME", "GMED", "GNTX", "GPK", "GTES", "GTLB",
  "GWRE", "GXO", "H", "HALO", "HEI", "HHH", "HIG", "HII", "HIW", "HLI", "HLNE", "HLT",
  "HOG", "HOOD", "HR", "HRB", "HUBS", "HUN", "HXL", "IAC", "IBKR", "IDA", "INGR", "INSM",
  "INSP", "IONS", "IOT", "IPGP", "IRDM", "ITT", "JAZZ", "JEF", "JHG", "JLL", "KBR", "KD",
  "KEX", "KNSL", "KNX", "KRC", "LAD", "LAMR", "LAZ", "LCID", "LEA", "LECO", "LFUS", "LII",
  "LITE", "LNC", "LNG", "LOPE", "LPLA", "LPX", "LSCC", "LSTR", "LYFT", "M", "MAN", "MANH",
  "MASI", "MAT", "MDB", "MDU", "MEDP", "MIDD", "MKL", "MKSI", "MLI", "MORN", "MP", "MPT",
  "MRVL", "MSA", "MSM", "MSTR", "MTDR", "MTG", "MTN", "MTSI", "MTZ", "MUSA", "NBIX", "NET",
  "NFG", "NLY", "NNN", "NOV", "NTNX", "NTRA", "NU", "NVST", "NVT", "NXST", "NYT", "OC",
  "OGE", "OHI", "OKTA", "OLED", "OLLI", "OLN", "OMF", "ONON", "ONTO", "ORI", "OSK", "OVV",
  "OWL", "OZK", "PAG", "PANW", "PATH", "PB", "PCTY", "PEGA", "PEN", "PENN", "PFGC", "PINS",
  "PK", "PLNT", "PLTR", "PNFP", "POST", "PPC", "PR", "PRGO", "PRI", "Q", "QGEN", "QS",
  "QSR", "R", "RARE", "RBA", "RBC", "RBLX", "RBRK", "RDDT", "REXR", "REYN", "RGA", "RGEN",
  "RGLD", "RH", "RITM", "RIVN", "RKLB", "RKT", "RLI", "RNG", "RNR", "ROKU", "RPM", "RPRX",
  "RRC", "RRX", "RS", "RVMD", "RYAN", "RYN", "S", "SAIA", "SAIC", "SAM", "SCCO", "SCI",
  "SEIC", "SF", "SFM", "SIRI", "SITE", "SLGN", "SLM", "SMCI", "SMG", "SMMT", "SN", "SNDR",
  "SNOW", "SNX", "SOFI", "SOLV", "SON", "SPOT", "SRPT", "SSB", "SSD", "SSNC", "ST", "STAG",
  "STWD", "SUI", "SW", "TDC", "TEAM", "TEM", "THC", "THG", "THO", "TKO", "TKR", "TLN",
  "TNL", "TOL", "TOST", "TPG", "TPL", "TREX", "TRU", "TTC", "TTD", "TTEK", "TW", "TWLO",
  "TXRH", "U", "UA", "UAA", "UGI", "UI", "UNM", "USFD", "UTHR", "VEEV", "VIRT", "VMI",
  "VNO", "VNOM", "VNT", "VOYA", "VRSK", "VRT", "VVV", "W", "WAL", "WBS", "WCC", "WDAY",
  "WEN", "WEX", "WFRD", "WH", "WING", "WLK", "WMS", "WPC", "WSC", "WSM", "WSO", "WTFC",
  "WTRG", "WU", "WWD", "XP", "XPO", "YETI", "Z", "ZG", "ZION", "ZM", "ZS",
]);

// Russell 2000 universe is not bundled with the engine; the Iter77
// bridge intentionally exposes this constant as `null` so the
// source selector can render a disabled / explanatory state.
export const RUSSELL_2000_UNIVERSE = null;
